import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { StockBadge } from "./StockBadge";

const item = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export function PartCard({ part }) {
  return (
    <motion.div variants={item} data-testid={`product-card-${part.sku}`} className="group relative bg-carbon border border-amber-500/10 rounded-md overflow-hidden hover:border-amber-500/40 transition-colors duration-300">
      <div className="relative h-48 overflow-hidden">
        <img src={part.image} alt={part.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
        <StockBadge status={part.stock_status} sku={part.sku} />
      </div>
      <div className="p-5">
        <span data-testid={`product-sku-${part.sku}`} className="text-xs font-mono font-semibold tracking-wider text-amber-400/90 bg-amber-950/40 border border-amber-500/30 px-2 py-0.5 rounded">
          {part.sku}
        </span>
        <h3 className="text-base font-bold text-white mt-3 leading-snug line-clamp-2">{part.name}</h3>
        <p className="text-xs text-zinc-500 mt-1">{part.category}</p>
        <div className="flex items-center justify-between mt-4">
          <span className="font-display text-2xl text-amber-light">${part.price.toLocaleString()}</span>
          <div className="flex gap-2">
            <Link to={`/parts/${part.sku}`} data-testid={`product-view-btn-${part.sku}`} className="text-xs font-mono uppercase text-zinc-400 hover:text-white border border-zinc-700 rounded px-2.5 py-1.5">
              View
            </Link>
            <Link
              to={`/quote?sku=${part.sku}`}
              data-testid={`product-request-quote-btn-${part.sku}`}
              className="text-xs font-mono uppercase text-obsidian bg-amber-light hover:bg-white rounded px-2.5 py-1.5"
            >
              Quote
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
